import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { EdContextMenuOptionsModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { SECTION_TYPES} from '@/content/values/sections';
import KEYS from '@/values/keys';
import { COURSE_EVENTS } from '@/content/values/events';
import EdSectionFolderIcon from '../ed-section-folder-icon/ed-section-folder-icon.vue';
import ToolService from '@/providers/tools';
import EdUpdateSubjectProjectComponent from '../ed-update-subject-project/ed-update-subject-project.component.vue';
import { ProjectsMixin } from '@/courses/mixins/projects.mixin';
import { ContentType } from '@/content/types/content.types';

@Component({
  name: 'ed-section-projects-folder',
  components: {
    EdSectionFolderIcon,
    EdUpdateSubjectProjectComponent
  }
})
export default class EdSectionProjectsFolder extends Mixins(ProjectsMixin) {

  /* Props */
  @Prop() readonly select: any;
  @Prop() readonly selected: any;
  @Prop() readonly open: any;
  @Prop() readonly opened: any;
  @Prop() readonly goToProject: any;
  @Prop() readonly level: any;
  @Prop() readonly parentId: any;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;

  /* Data */
  public titleID: string = '';
  public position: any = { x : 0, y: 0 };
  public isLoading: boolean = false;
  public menuAddOptions: any = [];
  public menuOptions : any = [];

  /* Computed */
  get membersConnected() {
    return this.$store.state.AppStore.membersPosition.filter(m => {
      let childrenSelected = SectionsProvider.getProjectByID(
        this.project.projects, m.sectionId
      );
      let folderSelected = (m.sectionId == this.project.projectId);
      return (
        m.courseId == this.courseID && 
        m.classId == this.classID &&
        (childrenSelected || folderSelected)
      );
    });
  }

  get state() {
    let paddingLeft = `edg-pad-left--${this.level == 1 ? this.level * 10 : this.level * 10}`;
    return { 
      container: { 
        'ed-section-projects-folder--selected': this.selected,
        [paddingLeft]: true
      }
    }
  }

  get nameSectionStyle() {
    let nameSectionStyle = this.options.editable ? {
      maxWidth: 'calc(100% - 110px)'
    } : {};
    return nameSectionStyle
  }

  get nameStyle() {
    return { maxWidth: `calc(100% - ${30 + (this.membersConnected.length * 15)}px` };
  }

  get teacherOnly() {
    let parent = SectionsProvider.getProjectByID(
      this.course.projects,
      this.parentId
    );
    if(parent) {
      return parent.section?.teacherOnly ? parent.section?.teacherOnly : this.project.section?.teacherOnly;
    } else {
      return this.project.section?.teacherOnly || false;
    }
  }

  get escapedName() {
    return ToolService.exitSpecialChars(this.project.name);
  }

  /* Methods */
  private setOptionsMenu() {
    this.menuAddOptions = [{
      type: SECTION_TYPES.PROJECT.code,
      text: this.$i18n.t('common.folder'),
      icon: SECTION_TYPES.SECTION.icon,
      borderBottom:true,
    },
    {
      type: 2,
      text: this.$t('common.files'),
      borderBottom: false
    }]
  }

  selectItem() {
    if(this.options.selectable) {
      this.$emit('goToProject');
      if(!this.opened){
        this.$emit('open');
      }
    }
  }

  toggleOpened() {
    this.$emit('goToProject');
    this.$emit('open');
  }

  goToAddObject(optionSelected = new EdContextMenuOptionsModel({})) {
    switch(optionSelected.type) {      
      case SECTION_TYPES.PROJECT.code:
        this.selectItem();
        this.goToCreateProject();
      break;
      default:
        this.$EdModal.createModal(EdUpdateSubjectProjectComponent, {
          course: this.course, 
          classId: this.classID, 
          courseId: this.courseID,
          project: this.project,
          contentType: this.contentType,
        });
      break;
    }
  }

  async selectEditOption(optionSelected: EdContextMenuOptionsModel) {
    if(optionSelected.type) {
      if(optionSelected.type == COURSE_EVENTS.EDIT_PROJECT) {
        this.selectItem();
      } else {
        this.isLoading = true;
        let data = {projectId: this.project.projectId, 
        courseId: this.courseID , classId: this.classID};
        this.$emit('selectProject', {projectId : this.project.projectId});
        await this.removeProject(data);
        this.isLoading = false;
      }
    }
  }
  
  getEditProjectMenu() {
    return [
      new EdContextMenuOptionsModel({
        id: 1,
        text: this.$t('common.edit'),
        type: COURSE_EVENTS.EDIT_PROJECT,
        borderBottom: true
      }),
      new EdContextMenuOptionsModel({
        id: 2,
        text: this.$t('common.remove'),
        type: COURSE_EVENTS.REMOVE_PROJECT,
        borderBottom: true
      })
    ]
  }

  /* Hooks */
  created() {
    this.setOptionsMenu();
  }

  mounted() {
    this.menuOptions = this.getEditProjectMenu();
    this.titleID = `${KEYS.PRE_PROJECT_ID}${this.project.projectId}`;
  }

  beforeUpdate() {
    this.setOptionsMenu();
    this.menuOptions = this.getEditProjectMenu();
  }
}